import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getDestinationById } from '../../../reducers/redux/actions/destinations.actions';
import { selectSelectedDestination } from '../../../reducers/redux/selectors/destinations.selectors';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../reducers/services/auth.service';
import AuthActions from '../../../reducers/redux/actions/auth.actions';

@Component({
  selector: 'app-lead-form-thank-you',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './thank-you.component.html',
  styleUrl: './thank-you.component.scss',
  providers: [],
})
export class LeadThankYouComponent {
  destination$!: Observable<any>;
  private store = inject(Store);
  private router = inject(Router);
  phoneOTPShow: boolean = false;
  @Output() closeLeadForm = new EventEmitter<void>();
  @Input() data: any;

  constructor(private authService: AuthService) {}

  closeModal() {
    this.closeLeadForm.emit();
  }

  goToDashboard() {
    if (this.authService.isAuthenticated()) {
      this.closeModal();
      this.router.navigate(['/users/dashboard']);
      return;
    }
    this.onSubmitPhone();
    this.closeModal();
  }

  onSubmitPhone(): void {
    const payload = { email: this.data?.email };
    this.authService.phoneOTPSend(payload).subscribe({
      next: (response) => {
        this.phoneOTPShow = !(
          response?.error || response?.error?.statusCode === 400
        );
        this.handleOTPResponse(payload);
      },
      error: (error) => {
        console.error('Login failed', error);
        this.phoneOTPShow = false;
        this.handleOTPResponse(payload);
      },
    });
  }

  bookingMessage(frame: string): string {
    switch (frame) {
      case 'immediate':
        return 'Planning to book : Immediate';
      case 'this_week':
        return 'Planning to book : This Week';
      case 'this_month':
        return 'Planning to book : This Month';
      case 'later_sometime':
        return 'Planning to book : Later Sometime';
      default:
        return '';
    }
  }

  private handleOTPResponse(payload: any): void {
    const otpData = { status: this.phoneOTPShow, leadEmail: payload };
    this.store.dispatch(AuthActions.SetOtpResponse({ otpResponse: otpData }));
    this.router.navigate(['/users/login']);
  }

  // separateCountryCode(phone: string): {
  //   countryCode: string;
  //   phoneNumber: string;
  // } {
  //   const match = phone.match(/^(\+\d+)(\d{10})$/);

  //   if (!match) {
  //     throw new Error(
  //       'Invalid phone number format. Ensure the format is +<country code><10-digit phone number>.',
  //     );
  //   }

  //   const countryCode = match[1];
  //   const phoneNumber = match[2];

  //   return { countryCode, phoneNumber };
  // }
}
